<template>
  <div class="nav">
    <div class="nav-bar">
      <!--<div class="user">-->
      <!--<div class="user-header">-->

      <!--</div>-->
      <!--<p>{{info.name}}<i class="iconfont icon-sitting"></i></p>-->

      <!--</div>-->
      <div class="router-list">
        <div class="router-item" :key='index' :class="{active:$route.path===item.href}"
             v-for="(item,index) in routerList.now">
          <router-link :to="{path:item.href,params:item.params}" replace>
            <i class="iconfont " :class="item.icon"></i><span class="item-title">{{item.title}}</span>
          </router-link>
        </div>


      </div>

      <div class="bottom-list router-list">
        <div class="router-item">
          <a @click="logout">
            <i class="iconfont icon-tuichu"></i><span class="item-title">退出登陆</span>
          </a>
        </div>

      </div>


    </div>

  </div>

</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: "navbar",
    computed: {
      ...mapState({
        info: state => state.account.info
      })
    },
    data() {
      return {
        routerList: {
          now:[],
          admin: {},
          manager: [
            {
              title: '状态总览',
              href: '/leemma/dashboard',
              icon: 'icon-all',
              params: {type: 'list'}
            },
            {
              title: '员工管理',
              href: '/leemma/users',
              icon: 'icon-tuandui',
              params: {type: 'list'}

            },
            {
              title: '设备管理',
              href: '/leemma/devices',
              icon: 'icon-tian',
              params: {type: 'list'}

            },
            {
              title: '客户管理',
              href: '/leemma/customers',
              icon: 'icon-haoyouliebiao',
              params: {type: 'list'}

            },
            {
              title: '日志管理',
              href: '/leemma/logs',
              icon: 'icon-time',
              params: {type: 'list'}

            },
          ],
          engineer: [
            {
            title: '状态总览',
            href: '/leemma/dashboard',
            icon: 'icon-all',
            params: {type: 'list'}
          },
            {
              title: '设备管理',
              href: '/leemma/devices',
              icon: 'icon-tian',
              params: {type: 'list'}

            },

            {
              title: '日志管理',
              href: '/leemma/logs',
              icon: 'icon-time',
              params: {type: 'list'}

            },],
          employee: [

            {
              title: '状态总览',
              href: '/leemma/dashboard',
              icon: 'icon-all',
              params: {type: 'list'}
            },
            {
              title: '设备管理',
              href: '/leemma/devices',
              icon: 'icon-tian',
              params: {type: 'list'}

            },
            {
              title: '客户管理',
              href: '/leemma/customers',
              icon: 'icon-haoyouliebiao',
              params: {type: 'list'}

            },
          ],
          bottom: []
        }
      }
    },
    created(){
      this.checkUser();
    },
    mounted() {

    },
    methods: {
      clickRouterItem(index) {
        let route = this.routerList.now[index];
        console.log(this.$route)
        console.log(route)
        this.$router.push({path: route.href})
      },
      logout() {
        this.$http.delete('user_sessions/destroy', {params: {auth_token: 'default'}}).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            localStorage.removeItem('account')
            // location.reload()
            this.$router.push({path: '/leemmaLogin'})
          }

        })
      },
      //检测权限
      checkUser(){
        let role = this.info.role, list=this.routerList;
        switch (role){
          case 'employee':
            list.now=list.employee;
            break;
          case 'manager':
            list.now=list.manager;
            break;
          case 'engineer':
            list.now=list.engineer;
            break;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .nav {
    padding-top: 71px;
    height: 100%;
    position: fixed;
    top: 0;
    .nav-bar {
      background: $dark;
      width: pxTorem(240px);
    }
    .user {
      text-align: center;
      padding: 2rem 0;
      width: 100%;
      .iconfont {
        margin-left: 5px;
      }
    }
    .user-header {
      display: inline-block;
      height: pxTorem(50px);
      width: pxTorem(50px);
      border-radius: 50%;
      border: 1px solid #ccc;

    }
    .router-list {
      list-style: none;
    }
    .router-item {
      background: transparent;
      color: #ccc;

      .iconfont {
        margin: 0 pxTorem(30px) 0 pxTorem(8px);
        font-size: pxTorem(20px);
      }
      a {
        display: block;
        color: #fff;
        text-decoration: none;
        padding: pxTorem(10px) pxTorem(15px);
        font-size: pxTorem(20px);
        cursor: pointer;
      }
    }
    .active {
      padding-left: 8px;
      background: #03a9f5;
      a {
        background: #1f2037;
        color: #03a9f5;
        padding-left: 7px;
      }
    }
    .router-item:hover {
      a {
        color: #03a9f5;
        text-decoration: none;
        background: #4d4f89;
      }
    }
    .bottom-list {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
    }
  }

  @media (max-width: 991px) {

    .nav {
      width: 50px;
      .nav-bar {
        width: 100%;
      }
      .router-item a {
        padding: 10px 6px;
      }
      .user {
        display: none;
      }
    ;
      .item-title {
        display: none;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue